"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VengeanceAbilityHandler = exports.VengeanceActorAbilityFactory = exports.VengeanceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Burning_1 = require("../../core/effects/core/Burning");
const EffectOnHit_1 = require("../../core/effects/core/EffectOnHit");
const Registries_1 = require("../../core/state/Registries");
class VengeanceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Vengeance;
        this.__typeName = "Vengeance";
    }
}
exports.VengeanceAbilityArgs = VengeanceAbilityArgs;
let VengeanceActorAbilityFactory = class VengeanceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Vengeance", "Self", 0);
    }
};
VengeanceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Vengeance")
], VengeanceActorAbilityFactory);
exports.VengeanceActorAbilityFactory = VengeanceActorAbilityFactory;
let VengeanceAbilityHandler = class VengeanceAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence: sequence.pushSequence("sequential"),
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
            effect: new EffectOnHit_1.EffectOnHitEffectArgs("Vengeance", "Burns on hit", 50, new Burning_1.BurningEffectArgs("Power", 10), Duration_1.Duration.Ticks(8))
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
VengeanceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Vengeance)
], VengeanceAbilityHandler);
exports.VengeanceAbilityHandler = VengeanceAbilityHandler;
